export interface IMailServer {
    host?: string;
    port?: number;
    username?: string;
    password?: string;
    enabled?: boolean;
    smtpAuth?: boolean;
    startTlsRequired?: boolean;
    startTlsEnabled?: boolean;
}

export class MailServer implements IMailServer {
    constructor(
        public host?: string,
        public port?: number,
        public username?: string,
        public password?: string,
        public enabled?: boolean,
        public smtpAuth?: boolean,
        public startTlsRequired?: boolean,
        public startTlsEnabled?: boolean
    ) {
        this.host = host ? host : '';
        this.port = port ? port : null;
        this.username = username ? username : '';
        this.password = password ? password : '';
        this.enabled = enabled ? enabled : false;
        this.smtpAuth = smtpAuth ? smtpAuth : true;
        this.startTlsRequired = startTlsRequired ? startTlsRequired : true;
        this.startTlsEnabled = startTlsEnabled ? startTlsEnabled : true;
    }
}
